import React from 'react';
import styles from './CenterInformations.module.sass';
import Card from '../../../components/Card';
import TextInput from '../../../components/TextInput';
import Switch from '../../../components/Switch';

const CenterInformations = ({ center, onCenterChange, onDropdownChange, onSwitchChange }) => {
    return (
        <Card className={styles.card} title="Informations du centre" classTitle="title-green">
            <div className={styles.group}>
                <TextInput
                    className={styles.field}
                    label="Nom du centre"
                    name="name"
                    type="text"
                    placeholder="Nom du centre"
                    value={center?.name || ''}
                    onChange={onCenterChange}
                    required
                />
                <TextInput
                    className={styles.field}
                    label="Numéro UAI"
                    name="uai_number"
                    type="text"
                    placeholder="Numéro UAI"
                    value={center?.uai_number || ''}
                    onChange={onCenterChange}
                    required
                />
                <TextInput
                    className={styles.field}
                    label="Numéro Siret"
                    name="siret_number"
                    type="number"
                    placeholder="Numéro Siret"
                    value={center?.siret_number || ''}
                    onChange={onCenterChange}
                    required
                />
                <TextInput
                    className={styles.field}
                    label="Numéro de déclaration d'activité"
                    name="nda_number"
                    type="number"
                    placeholder="Numéro de déclaration d'activité"
                    value={center?.nda_number || ''}
                    onChange={onCenterChange}
                />
                <TextInput
                    className={styles.field}
                    label="Numéro Siren"
                    name="siren_number"
                    type="number"
                    placeholder="Numéro Siren"
                    value={center?.siren_number || ''}
                    onChange={onCenterChange}
                    required
                />

                <div className={styles.field} style={{ display: 'flex', alignItems: 'center' }}>
                    <span style={{ marginLeft: '10px' }}>Centre de formation d'entreprise :</span>
                    <Switch
                        name="is_company_cfa"
                        value={center?.is_company_cfa || false}
                        onChange={(value) => onSwitchChange('is_company_cfa', value)}
                        className={styles.switch}
                    />
                </div>

                <div className={styles.field} style={{ display: 'flex', alignItems: 'center' }}>
                    <span style={{ marginLeft: '10px' }}>Lieu de formation principal :</span>
                    <Switch
                        name="main_cfa_location"
                        value={center?.main_cfa_location || false}
                        onChange={(value) => onSwitchChange('main_cfa_location', value)}
                        className={styles.switch}
                    />
                </div>

            </div>
        </Card>
    );
};

export default CenterInformations;